import { FC } from 'react'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { InvoiceDiscountForm, InvoiceRowForm } from '../../core/_models'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'

type props = {
  title: string,
  discountItem: {
    discountItem: InvoiceDiscountForm | null | undefined,
    setDiscountItem: React.Dispatch<React.SetStateAction<InvoiceDiscountForm | null | undefined>>
  }
}
const InvoiceDiscountEditModalHeader: FC<props> = ({ title, discountItem }) => {

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder text-primary'>
        <FieldHelpLabel label={title} helpKey='body[].dis' />
      </h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-invoices-modal-action='close'
        onClick={() => discountItem.setDiscountItem(undefined)}
        style={{ cursor: 'pointer' }}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export { InvoiceDiscountEditModalHeader }
